<script>
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'

export default {
  name: 'settings.shops',
  mixins: [tableMixin],
  data () {
    return {
      isLoading: false,
      search: null,
      showForm: false,
      selectedId: null,
      fields: [
        {
          key: 'name',
          label: 'Name',

          class: ' align-middle'
        },
        {
          key: 'is_active',
          label: 'Active',
          thStyle: { width: '100px' },
          class: 'text-center  align-middle'
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { width: '100px' },
          class: 'text-right align-middle'
        }
      ]
    }
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    customer_id: 'onRefresh',
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.currentPage = 1
        }
        this.onRefresh()
      }
    }
  },
  methods: {
    async onRefresh () {
      this.isLoading = true
      this.selectedId = null
      let { items, total_rows } = await api.shops.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        needle: this.search,
        orderBy: { name: 'asc', is_active: 'asc' },
        filters: []
      })
      this.data = [...items]
      this.totalRows = total_rows
      this.isLoading = false
    },
    onEdit (item) {
      this.selectedId = item.id
      this.showForm = true
    },

    onNewShop () {
      this.selectedId = null
      this.showForm = true
    },
    async onRemove (shop) {
      if (shop === undefined) return
      try {
        this.isLoading = true
        await api.shops.delete({
          id: shop.id
        })
        this.$bvToast.toast(`Shop '${shop.name}' was removed!`, {
          title: 'Shop Removed',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'success',
          autoHideDelay: 1000,
          appendToast: true
        })
        this.isLoading = false
        this.onRefresh()
      } catch (err) {
        this.$bvToast.toast(`${err}!`, {
          title: 'Error',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          autoHideDelay: 1000,
          appendToast: true
        })
        this.isLoading = false
      }
    }
  },
  computed: {}
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title">Shops</h4>
      <div class="my-4 d-flex justify-content-between align-items-center">
        <g-search-input
          v-model="search"
          placeholder="Find Shops"
          width="300px"
          class="mr-0 mr-2"
        /><b-btn class="btn-label" variant="primary" v-on:click="onNewShop">
          <i class="bx bx-plus label-icon"></i>New Shop
        </b-btn>
      </div>
      <b-table
        :show-empty="true"
        hover
        :items="data"
        :fields="fields"
        :busy="isLoading"
        head-variant="primary"
        thead-tr-class="border-bottom bg-light"
        tbody-tr-class="border-bottom "
        borderless
      >
        <template v-slot:cell(is_active)="{ item }">
          <i class="far fa-check-circle text-success" v-if="item.is_active"></i>
          <i class="fas fa-ban text-danger" v-else></i>
        </template>

        <template v-slot:cell(actions)="row">
          <div class="d-flex align-items-center m-0 p-0">
            <b-button
              variant="link"
              size="sm"
              @click="onEdit(row.item)"
              class="align-self-center mr-1"
            >
              <i class="far fa-edit"></i>
            </b-button>
            <b-button
              variant="link"
              size="sm"
              @click="onRemove(row.item)"
              class="align-self-center"
            >
              <i class="fas fa-trash-alt text-danger"></i>
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="d-flex align-items-center justify-content-between p-0 mt-2">
        <div class="dataTables_length" v-if="totalRows > minPerPage">
          <label class="d-inline-flex align-items-center m-0">
            Show
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="mx-2"
            ></b-form-select
            >Entries
          </label>
        </div>

        <b-pagination
          v-if="perPage !== 'All' && totalRows > perPage"
          class="pagination mb-0"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
        >
          <template v-slot:page="{ page, active }">
            <b v-if="active">{{ page }}</b>
            <i v-else>{{ page }}</i>
          </template>
        </b-pagination>
      </div>
      <app-shop-form-dialog
        :visible.sync="showForm"
        :shopId="selectedId"
        ref="shop-form"
        v-on:created="onRefresh"
      />
    </b-card>
  </g-overlay>
</template>
